import dom from '../../utils/dom';
import { StateFilterData } from '../../forms/address/types';
import { IRecaptchaSettings } from '../../utils/RecaptchaService';
import AccountCreateUpdateFormHandler from '../AccountCreateUpdateFormHandler';

window.tnew.page.initialize = ({ isAddressVerificationEnabled, stateFilterConfig, recaptchaSettings }: {
  isAddressVerificationEnabled: boolean,
  stateFilterConfig: StateFilterData,
  recaptchaSettings: IRecaptchaSettings,
}) => {
  const $form = dom.find('#tn-account-register-form') as HTMLFormElement | null;

  const isAddressSectionDisplayed = true;

  if ($form) {
    new AccountCreateUpdateFormHandler($form, isAddressVerificationEnabled, stateFilterConfig, isAddressSectionDisplayed, recaptchaSettings, null);
  }
};
